import React, { FunctionComponent, useState } from 'react'
import { StyledBurger, StyledBurgerMenu, StyledBurgerStripes } from 'components/Navigation/NavigationBurger/style'
import { SortableContainer, SortEnd } from 'react-sortable-hoc'
import NavigationList from 'components/Navigation/NavigationList'
import { Wrapper as ItemWrapper } from 'components/Navigation/NavigationItem/style'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useWindowDimensions } from '../../../helpers/hooks/useWindowDimensions/useWindowDimensions'
import { NavigationLogo, NavigationLogoWrapper } from 'components/Navigation/style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IPageItem } from 'store/page/types'

export interface Props {
  localPages: IPageItem[]
  currentPage: IPageItem
  onSortEnd: (sortEnd: SortEnd) => void
  locale: string
  screenClass: string
  setLogoOpen: (logoOpen: boolean) => void
  logoSrc: string | undefined
}

export const NavigationBurger: FunctionComponent<Props> = ({
  currentPage,
  localPages,
  onSortEnd,
  locale,
  screenClass,
  setLogoOpen,
  logoSrc,
}) => {
  const { t } = useTranslation()
  const [isDragActive, setIsDragActive] = useState<boolean>(false)
  const { windowWidth } = useWindowDimensions()
  const [isOpen, setIsOpen] = useState(false)

  const SortableNavigationList = SortableContainer(NavigationList)

  const themeTitle = localStorage.getItem('theme-ui-color-mode') || 'Classic'

  const handleSortEnd = (sortEnd: SortEnd) => {
    onSortEnd(sortEnd)
    setIsDragActive(false)
  }
  return (
    <div>
      <StyledBurger open={isOpen} onClick={() => setIsOpen(!isOpen)}>
        <StyledBurgerStripes open={isOpen} />
        <StyledBurgerStripes open={isOpen} />
        <StyledBurgerStripes open={isOpen} />
      </StyledBurger>
      {isOpen && (
        <StyledBurgerMenu open={isOpen}>
          <NavigationLogoWrapper>
            <NavigationLogo onClick={() => setLogoOpen(true)} src={logoSrc + '&w=100&h=80'} alt="navigation-logo" />
          </NavigationLogoWrapper>
          <SortableNavigationList
            /* @ts-expect-error */
            items={localPages}
            currentPage={currentPage}
            onSortStart={() => setIsDragActive(true)}
            onSortEnd={handleSortEnd}
            axis={'x'}
            distance={10}
            isDragActive={isDragActive}
            open={isOpen}
          />

          <ItemWrapper width={windowWidth} themeTitle={themeTitle}>
            <Link className={screenClass} to="/page/new">
              <FontAwesomeIcon icon={'circle-plus'} /> {t('page:add_page', { lng: locale })}
            </Link>
          </ItemWrapper>
        </StyledBurgerMenu>
      )}
    </div>
  )
}
